import { VUE_APP_IMG_URL } from "@/config"
// 增加图片前缀
export function addImgUrl(url){
    return VUE_APP_IMG_URL + url
}

// 判断是否为对象
export function isJson(str){
    return Object.prototype.toString.call(str) === "[object Object]"
}

// 前往登录
export function toLogin(that){
    that.$router.push({
        path:"/login",
        query:{
            path:that.$route.path,
            query:JSON.stringify(that.$route.query)
        }
    })
}